import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MenuItem } from 'primeng/api';
import { AuthenticationService } from '@app/core/authentication/authentication.service'; import { ActivatedRoute, Router } from '@angular/router';
import { label } from '@app/constants/labels';
import { rolesdef } from '@app/constants/role-def';
import { BaseAPIService } from '../../Services/api.base.service';
import { IBroadcastMessage } from '../../Models/IBroadcastMessage';

@Component({
  selector: 'app-shell',
  standalone: false,
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss'],
})
export class ShellComponent implements OnInit, OnDestroy {
  
  isSidebarCollapsed = false;
  isLoggedIn = false;
  private loginSubscription: Subscription;
  
  labels: any;
  roleCd: string;
  roles: any;
  isAlarmSubMenu: boolean;
  isMgmtSubMenu: boolean = false;
  isGrpSubMenu: boolean;
  isDataExprtSubMenu: boolean;
  mgmtLink: string;
  broadcastMessage: string = '';
  showMore: boolean = false;
  showBroadcastMessage: boolean = false;
  showBroadcastMessagebanner: boolean = false;
  showMoreDialog: boolean = false;
  broadcastMessagelong: string;

   constructor(private route: ActivatedRoute, private readonly baseService: BaseAPIService, private readonly authService: AuthenticationService, public readonly router: Router) {
    const paramValue = this.route.snapshot.queryParamMap.get('message');
    if (paramValue == 'true') {
      this.showBroadcastMessagebanner = true;
      localStorage.setItem("showBroadcastMessagebanner", 'true');
    } else {
      this.showBroadcastMessagebanner = false;
    }

  }

  onSidebarToggle() {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
    this.isExpanded = !this.isExpanded;
  }

  ngOnDestroy(): void {
    if (this.loginSubscription) {
      this.loginSubscription.unsubscribe();
    }
  }

  isExpanded = true;


  items: MenuItem[];
  ngOnInit() {
    this.loginSubscription = this.authService.userLoginIn$.subscribe(loggedIn => {
      this.isLoggedIn = loggedIn;
    });
    this.isLoggedIn = this.authService.isAuthenticated();

    this.labels = label;
    this.roles = rolesdef;
    this.roleCd = this.authService.authenticatedRoleCd;
    this.isAlarmSubMenu = ['/rules', '/alarms'].includes(this.router.url) ? true : false;
    this.isMgmtSubMenu = ['/device', '/users', '/drivermanager', '/oem', '/device-metadata'].includes(this.router.url) ? true : false;
    this.isGrpSubMenu = ['/devicegroups'].includes(this.router.url) ? true : false;
    this.isDataExprtSubMenu = ['/haccpreports', '/export'].includes(this.router.url) ? true : false;
    if (this.roleCd === this.roles.master || this.roleCd === this.roles.enduser || this.roleCd === this.roles.cuserW) {
      this.mgmtLink = '/users';
    } else {
      this.mgmtLink = '/device';
    }

    if (JSON.parse(localStorage.getItem("showBroadcastMessagebanner"))) {
      this.getBroadcastMessages();
    } else {
      this.showBroadcastMessagebanner = false;
    }
  }
  closeBroadcastmessage() {
    this.showBroadcastMessagebanner = false;
    localStorage.setItem("showBroadcastMessagebanner", 'false');
  }
  getBroadcastMessages() {
    const apiUrl = '/BroadcastMessage/GetActiveBroadcastMessage';
    this.baseService.GET(apiUrl)
      .subscribe((response: IBroadcastMessage) => {
        if (response != undefined && response != null) {
          this.showBroadcastMessagebanner = JSON.parse(localStorage.getItem("showBroadcastMessagebanner"));
          this.broadcastMessagelong = response.message;
          if (response.message.length > 425) {
            this.broadcastMessage = response.message.substring(0, 425);
            this.showMore = true
          } else {
            this.broadcastMessage = response.message;
          }
          this.showBroadcastMessagebanner = true;

        } else {
          this.showBroadcastMessagebanner = false;
        }
      });
  }
  showMoreMessage() {
    this.showMoreDialog = true;
  }
  closeShowMore() {
    this.showMoreDialog = false;
  }
  clearAllMenu(event: Event) {
    this.isMgmtSubMenu = this.isAlarmSubMenu = this.isGrpSubMenu = this.isDataExprtSubMenu = false;

  }
  DashboardNav(event: Event) {
    this.clearAllMenu(event)
  }
  AlarmNav(event: Event) {
    this.isMgmtSubMenu = this.isGrpSubMenu = this.isDataExprtSubMenu = false;
    this.isAlarmSubMenu = true;
  }
  GrpNav(event: Event) {
    this.isMgmtSubMenu = this.isAlarmSubMenu = this.isDataExprtSubMenu = false;
    this.isGrpSubMenu = true;
  }
  MgmtNav(event: Event) {
    this.isGrpSubMenu = this.isAlarmSubMenu = this.isDataExprtSubMenu = false;
    this.isMgmtSubMenu = true;
  }
  DataExpt(event: Event) {
    this.isGrpSubMenu = this.isAlarmSubMenu = this.isMgmtSubMenu = false;
    this.isDataExprtSubMenu = true;
  }
}
